import { BusinessServices, Country, IUser, Roles } from '@shs-digi-care-monorepo/interfaces';
import { getAssignedCountries, roleNamesForStream } from '@shs-digi-care-monorepo/frontend-lib/util';
import { OmEmeaCountryOptions } from '../enums/countries.enum';

/** All EMEA country codes derived from OmEmeaCountryOptions */
export const ALL_EMEA_COUNTRIES: Country[] = Object.keys(OmEmeaCountryOptions) as Country[];

/**
 * Countries the user operates in. An EMEA admin administers the whole stream and
 * therefore covers every supported country, while everyone else is limited to the
 * countries their roles are scoped to.
 */
export function emeaCountriesOf(user: IUser | null | undefined): Country[] {
    if (!user) {
        return [];
    }

    return roleNamesForStream(user, BusinessServices.OM_EMEA).includes(Roles.ADMIN)
        ? ALL_EMEA_COUNTRIES
        : getAssignedCountries(user, BusinessServices.OM_EMEA);
}

/**
 * Countries the user works tasks in. Only task owner assignments count, so an
 * admin is limited to the countries they own tasks in instead of the whole
 * EMEA stream.
 */
export function emeaTaskOwnerCountriesOf(user: IUser | null | undefined): Country[] {
    const countries = (user?.userRoles ?? [])
        .filter(
            ({ role }) => role.stream === BusinessServices.OM_EMEA && role.name === Roles.TASK_OWNER && !!role.country
        )
        .map(({ role }) => role.country as Country);

    return [...new Set(countries)];
}
